import { render, staticRenderFns } from "./PatientImagesForm.vue?vue&type=template&id=2c154ed8&"
import script from "./PatientImagesForm.vue?vue&type=script&lang=js&"
export * from "./PatientImagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports